import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FileMimeType, TaskViewType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Label, Text } from '@yoweb/ui/components/typography';
import { Divider } from '@yoweb/ui/components/Divider';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { formatMoney } from '@yoweb/utils/money';
import { useUser } from '@poplar/hooks/useUser';
import { getFormattedChoiceValue, getTimeDateSummary, getLocalizedAddressString } from './intake-form/utils';
import { MONEY_NANOS_MAX } from '@poplar/constants/intake';
import { MediaImage } from '@poplar/components/MediaImage';
import { API_MEDIA, API_MEDIA_INFO, API_MEDIA_THUMBNAIL } from '@poplar/constants/routes';
import { Grid } from '@yoweb/ui/components/Grid';
import { isDocument, isSupportedImageMimeType } from '@poplar/utils/file';
import { fetchJson } from '@yoweb/utils/fetchJson';
import Spinner from '@yoweb/ui/components/Spinner';
import { ButtonLink } from '@yoweb/ui/components/buttons';
import { formatPartialDate } from '@yoweb/utils/date';
import { ImageGalleryModal } from '@poplar/components/ImageGalleryModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getAnswerSummary = function getAnswerSummary(answer, locale, timeZone, t) {
  var _answer$idonotknowAns, _answer$idonotknowAns2;

  var answerSummary = {};

  if (answer.integerAnswer) {
    var _answer$integerAnswer, _answer$integerAnswer2;

    answerSummary = {
      label: answer.integerAnswer.inputFieldHint,
      value: (_answer$integerAnswer = answer.integerAnswer.answeredValue) === null || _answer$integerAnswer === void 0 ? void 0 : (_answer$integerAnswer2 = _answer$integerAnswer.value) === null || _answer$integerAnswer2 === void 0 ? void 0 : _answer$integerAnswer2.toString()
    };
  }

  if (answer.doubleAnswer) {
    var _answer$doubleAnswer$, _answer$doubleAnswer$2;

    answerSummary = {
      label: answer.doubleAnswer.inputFieldHint,
      value: (_answer$doubleAnswer$ = answer.doubleAnswer.answeredValue) === null || _answer$doubleAnswer$ === void 0 ? void 0 : (_answer$doubleAnswer$2 = _answer$doubleAnswer$.value) === null || _answer$doubleAnswer$2 === void 0 ? void 0 : _answer$doubleAnswer$2.toString()
    };
  }

  if (answer.booleanAnswer) {
    var _answer$booleanAnswer;

    var answeredValue = (_answer$booleanAnswer = answer.booleanAnswer.answeredValue) === null || _answer$booleanAnswer === void 0 ? void 0 : _answer$booleanAnswer.value; // Avoid showing 'no' on falsy values

    var value = undefined;

    if (answeredValue !== undefined) {
      value = answeredValue ? t('yes') : t('no');
    }

    answerSummary = {
      label: answer.booleanAnswer.inputFieldHint,
      value: value
    };
  }

  if (answer.textAnswer) {
    var _answer$textAnswer$an;

    answerSummary = {
      label: answer.textAnswer.inputFieldHint,
      value: (_answer$textAnswer$an = answer.textAnswer.answeredValue) === null || _answer$textAnswer$an === void 0 ? void 0 : _answer$textAnswer$an.value
    };
  }

  if (answer.singleChoiceAnswer) {
    answerSummary = {
      value: getFormattedChoiceValue(answer.singleChoiceAnswer.answeredValue, answer.singleChoiceAnswer.choiceDataType, locale, timeZone)
    };
  }

  if (answer.multipleChoicesAnswer) {
    var _answer$multipleChoic;

    var type = answer.multipleChoicesAnswer.choiceDataType;
    answerSummary = {
      value: (_answer$multipleChoic = answer.multipleChoicesAnswer.answeredValuesList) === null || _answer$multipleChoic === void 0 ? void 0 : _answer$multipleChoic.map(function (value) {
        return getFormattedChoiceValue(value, type, locale, timeZone);
      }).join(', ')
    };
  }

  if (answer.dateAnswer) {
    var _answer$dateAnswer$an;

    var seconds = (_answer$dateAnswer$an = answer.dateAnswer.answeredDate) === null || _answer$dateAnswer$an === void 0 ? void 0 : _answer$dateAnswer$an.seconds;
    answerSummary = {
      label: answer.dateAnswer.inputFieldHint,
      value: getTimeDateSummary(seconds, {
        locale: locale,
        timeZone: timeZone,
        preset: 'defaults'
      })
    };
  }

  if (answer.dateTimeAnswer) {
    var _answer$dateTimeAnswe;

    var _seconds = (_answer$dateTimeAnswe = answer.dateTimeAnswer.answeredDateTime) === null || _answer$dateTimeAnswe === void 0 ? void 0 : _answer$dateTimeAnswe.seconds;

    answerSummary = {
      label: answer.dateTimeAnswer.inputFieldHint,
      value: getTimeDateSummary(_seconds, {
        locale: locale,
        timeZone: timeZone,
        preset: 'timeAndDate'
      })
    };
  }

  if (answer.monthAndDayAnswer) {
    var _answeredValue = answer.monthAndDayAnswer.answeredValue;
    answerSummary = {
      value: formatPartialDate({
        month: _answeredValue === null || _answeredValue === void 0 ? void 0 : _answeredValue.month,
        day: _answeredValue === null || _answeredValue === void 0 ? void 0 : _answeredValue.day
      }, {
        locale: locale,
        preset: 'defaults'
      })
    };
  }

  if (answer.moneyAnswer) {
    var answeredMoney = answer.moneyAnswer.answeredMoney;

    if (!answeredMoney) {
      return {};
    }

    var cents = 0;
    var units = answeredMoney.units,
        nanos = answeredMoney.nanos,
        currencyCode = answeredMoney.currencyCode;

    if (nanos) {
      cents = nanos / MONEY_NANOS_MAX * 100;
    }

    var amount = parseFloat("".concat(units, ".").concat(cents.toString().padStart(2, '0')));
    answerSummary = {
      label: answer.moneyAnswer.inputFieldHint,
      value: answeredMoney ? formatMoney(locale, amount, {
        currency: currencyCode
      }) : undefined
    };
  }

  if (answer.addressAnswer) {
    answerSummary = {
      value: getLocalizedAddressString(answer.addressAnswer.answeredValue, locale)
    };
  }

  if ((_answer$idonotknowAns = answer.idonotknowAnswer) !== null && _answer$idonotknowAns !== void 0 && (_answer$idonotknowAns2 = _answer$idonotknowAns.answeredValue) !== null && _answer$idonotknowAns2 !== void 0 && _answer$idonotknowAns2.value) answerSummary = {
    value: t('task-intake-do-not-know')
  };

  if (answer.fileAnswer) {
    var _answer$fileAnswer$do, _answer$fileAnswer$do2;

    var uploadedThumbnails = (_answer$fileAnswer$do = (_answer$fileAnswer$do2 = answer.fileAnswer.documentsToUpload) === null || _answer$fileAnswer$do2 === void 0 ? void 0 : _answer$fileAnswer$do2.map(function (_ref) {
      var thumbnail = _ref.thumbnail,
          file = _ref.file,
          fileMimeType = _ref.fileMimeType;
      return {
        src: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url,
        name: file === null || file === void 0 ? void 0 : file.name,
        fileMimeType: fileMimeType
      };
    })) !== null && _answer$fileAnswer$do !== void 0 ? _answer$fileAnswer$do : [];
    var thumbnails = answer.fileAnswer.answeredValuesList.map(function (uuid) {
      return {
        fileUuid: uuid
      };
    });
    answerSummary = {
      label: answer.fileAnswer.inputFieldHint,
      thumbnails: [].concat(_toConsumableArray(thumbnails), _toConsumableArray(uploadedThumbnails))
    };
  }

  return _objectSpread(_objectSpread({}, answerSummary), {}, {
    instructionHint: answer.instructionHint
  });
};
export var getQuestionSummary = function getQuestionSummary(question, locale, timeZone, t) {
  return {
    id: question.id,
    title: question.title,
    answers: question.answerOptionsList.map(function (answerOption) {
      return getAnswerSummary(answerOption, locale, timeZone, t);
    }),
    hasDependentLogic: Boolean(question.dependentQuestionAnswerOptionIdentifiers && question.dependentQuestionAnswerOptionIdentifiers.dependentQuestionAnswerOptionIdentifiersList.length > 0),
    hasDefaultDestinationQuestionRule: Boolean(question.defaultDestinationQuestionIdentifier !== 0)
  };
};

var fetchFileInfo = function fetchFileInfo(_ref2) {
  var fileUuid = _ref2.fileUuid,
      name = _ref2.name,
      src = _ref2.src,
      fileMimeType = _ref2.fileMimeType;

  if (fileUuid) {
    return fetchJson("".concat(API_MEDIA_INFO, "/").concat(fileUuid));
  } // Show thumbnails of attached but not yet uploaded files


  return Promise.resolve({
    fileName: name !== null && name !== void 0 ? name : '',
    fileType: fileMimeType !== null && fileMimeType !== void 0 ? fileMimeType : FileMimeType.FILE_MIME_TYPE_UNSPECIFIED,
    src: src
  });
};

var MediaGrid = function MediaGrid(_ref3) {
  var files = _ref3.files,
      enableImagePreview = _ref3.enableImagePreview;

  var _useState = useState(),
      fileInfo = _useState[0],
      setFileInfo = _useState[1];

  var _useState2 = useState(),
      galleryImages = _useState2[0],
      setGalleryImages = _useState2[1];

  var _useState3 = useState(0),
      galleryIndex = _useState3[0],
      setGalleryIndex = _useState3[1];

  useEffect(function () {
    var fetchAllFileInfo = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var fileInfoRes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all(files.map(fetchFileInfo));

              case 2:
                fileInfoRes = _context.sent;
                setFileInfo(fileInfoRes);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchAllFileInfo() {
        return _ref4.apply(this, arguments);
      };
    }();

    void fetchAllFileInfo();
  }, [files]);

  if (!fileInfo) {
    return /*#__PURE__*/_jsx(Box, {
      height: 72,
      width: "100%",
      display: "flex",
      justifyContent: "center",
      justifyItems: "center",
      "data-testid": "media-thumbnail-container",
      children: /*#__PURE__*/_jsx(Spinner, {
        size: "md"
      })
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ImageGalleryModal, {
      images: galleryImages,
      onClose: function onClose() {
        return setGalleryImages(undefined);
      },
      setImageIndex: setGalleryIndex,
      imageIndex: galleryIndex
    }), /*#__PURE__*/_jsx(Grid, {
      columnGap: "normal1",
      rowGap: "normal1",
      columns: "repeat(auto-fill, 108px)",
      as: "ol",
      children: fileInfo.map(function (_ref5, i) {
        var uuid = _ref5.uuid,
            fileName = _ref5.fileName,
            fileType = _ref5.fileType,
            src = _ref5.src;

        // src is used to show attached, but not yet uploaded thumbnails during intake
        if (!uuid && !src) {
          return null;
        }

        var thumbnail = /*#__PURE__*/_jsx(MediaImage, {
          image: {
            src: src !== null && src !== void 0 ? src : "".concat(API_MEDIA_THUMBNAIL, "/").concat(uuid)
          },
          width: 108,
          height: 72,
          borderRadius: "small",
          fileName: fileName,
          isDocument: isDocument(fileType)
        });

        return enableImagePreview ? /*#__PURE__*/_jsx(NoStyledButton // eslint-disable-next-line react/no-array-index-key
        , {
          type: "button",
          "data-testid": "image-thumbnail",
          onClick: function onClick() {
            var clickedFile = fileInfo[i];

            if (isSupportedImageMimeType(clickedFile.fileType)) {
              var mapping = {};
              var imageSources = fileInfo.map(function (file, index) {
                if (isSupportedImageMimeType(file.fileType)) {
                  // Need to keep the original file index in-sync after filter
                  mapping[index] = Object.keys(mapping).length;
                  return "".concat(API_MEDIA, "/").concat(file.uuid);
                }
              }).filter(Boolean);
              var initialIndex = mapping[i];
              setGalleryIndex(initialIndex);
              setGalleryImages(imageSources);
            } else {
              window.location.href = "".concat(API_MEDIA, "/").concat(clickedFile.uuid, "/download");
            }
          },
          children: thumbnail
        }, "media-image-".concat(i)) : thumbnail;
      })
    })]
  });
};

export var Summary = function Summary(_ref6) {
  var questions = _ref6.questions,
      onEdit = _ref6.onEdit,
      enableImagePreview = _ref6.enableImagePreview,
      taskView = _ref6.taskView;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var meta = useIntlMeta();
  var user = useUser();
  var questionSummaries = questions.map(function (question) {
    return getQuestionSummary(question, meta.locale, user.timeZone, t);
  });

  var handleEdit = function handleEdit(index) {
    if (onEdit) {
      onEdit(questions[index].order);
    }
  };

  return /*#__PURE__*/_jsx(Box, {
    display: "grid",
    rowGap: "normal1",
    "data-testid": "question-summary",
    children: questionSummaries.map(function (_ref7, index) {
      var id = _ref7.id,
          title = _ref7.title,
          answers = _ref7.answers,
          hasDependentLogic = _ref7.hasDependentLogic,
          hasDefaultDestinationQuestionRule = _ref7.hasDefaultDestinationQuestionRule;
      return /*#__PURE__*/_jsxs("div", {
        "data-testid": "summary-question-".concat(id || index),
        children: [/*#__PURE__*/_jsxs(Box, {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: "small3",
          gap: "small4",
          children: [/*#__PURE__*/_jsx(Label, {
            "data-testid": "summary-question-title",
            children: title
          }), onEdit && (taskView !== TaskViewType.TASK_VIEW_TYPE_UPCOMING || !hasDependentLogic && !hasDefaultDestinationQuestionRule) && /*#__PURE__*/_jsx(ButtonLink, {
            "data-testid": "summary-edit-btn",
            onClick: function onClick() {
              return handleEdit(index);
            },
            children: t('actions.edit')
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          display: "grid",
          rowGap: "small4",
          children: [answers.map(function (_ref8, answerIndex) {
            var label = _ref8.label,
                value = _ref8.value,
                thumbnails = _ref8.thumbnails,
                instructionHint = _ref8.instructionHint;
            return (value || (thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length) || null) &&
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsxs(AnswerContainer, {
              children: [instructionHint && /*#__PURE__*/_jsx(Text, {
                variant: "muted2",
                size: "md",
                children: instructionHint
              }), label && /*#__PURE__*/_jsx(Text, {
                variant: "muted2",
                size: "md",
                children: label
              }), value && /*#__PURE__*/_jsx(Text, {
                whiteSpace: "pre-wrap",
                size: "md",
                children: value
              }), /*#__PURE__*/_jsx(Box, {
                mt: "small4",
                children: (thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length) && /*#__PURE__*/_jsx(MediaGrid, {
                  files: thumbnails,
                  enableImagePreview: enableImagePreview
                })
              })]
            }, "answer-".concat(id || index, "-").concat(answerIndex));
          }), answers.filter(function (_ref9) {
            var value = _ref9.value,
                thumbnails = _ref9.thumbnails;
            return value || (thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length);
          }).length === 0 && t('placeholder-dash')]
        }), index !== questionSummaries.length - 1 && /*#__PURE__*/_jsx(Box, {
          my: "normal2",
          children: /*#__PURE__*/_jsx(Divider, {
            variant: "sandMedium"
          })
        })]
      }, "question-".concat(id || index));
    })
  });
};
var AnswerContainer = styled.div.withConfig({
  componentId: "sc-1jhfn3f-0"
})(["min-width:0;overflow-wrap:break-word;"]);
var NoStyledButton = styled.button.withConfig({
  componentId: "sc-1jhfn3f-1"
})(["background:transparent;border:none;outline:none;cursor:pointer;padding:0;"]);